import React, { useEffect, useState } from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import { NotificationManager } from "react-notifications";
import { ReporteIndividualApi } from "./api/ReporteIndividualApi";
import { TrasladosApi } from "../../../api/TrasladosApi";
import Paginacion from "../../../../../Utils/Components/Paginacion/Paginacion";
import LoadMask from "../../../../../Utils/LoadMask/LoadMask";
import moment from "moment";
import { FiltrosReporte } from "../components/FiltosReporte";
import { ListadoIndividualTable } from "./components/ListadoIndividualTable";
import {
    dateToDayStart,
    dateToDayEnd,
    getErrorFromResponse,
} from "../../../../../../../utility/utils";
import { GraficaTraslados } from "../components/GraficaTraslados";
import { ModalIngresos } from "../../../components/ModalIngresos";

export const ReporteIndividual = ({ storageKey }) => {
    const STORAGE_KEY = storageKey;
    const savedState = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    const filtros = savedState && savedState.filtros ? savedState.filtros : {};

    const [fechaInicial, setFechaInicial] = useState(
        filtros.fecha_inicial ? moment(filtros.fecha_inicial) : null,
    );
    const [fechaFinal, setFechaFinal] = useState(
        filtros.fecha_final ? moment(filtros.fecha_final) : null,
    );

    const [traslados, setTraslados] = useState([]);
    const [trasladosGrafica, setTrasladosGrafica] = useState([]);
    const [totalesTraslados, setTotalesTraslados] = useState({});

    const [paginaSeleccionada, setPaginaSeleccionada] = useState(
        savedState.pagina || 1,
    );
    const [cantidadResultados, setCantidadResultados] = useState(0);

    const [trasladoSeleccionado, setTrasladoSeleccionado] = useState(null);

    const { getTrasladosReporte, cargando, obtenerReporteExcel } =
        ReporteIndividualApi();

    const { getTrasladoDetalle, cargando: cargandoDetalle } = TrasladosApi();

    const VerDetalleTraslado = async (trasladoId) => {
        try {
            const traslado = await getTrasladoDetalle(trasladoId);
            setTrasladoSeleccionado(traslado);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el detalle del traslado",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const construirParams = (page) => {
        const params = {};

        if (page) {
            params.page = page;
        }

        params.fecha_inicial = dateToDayStart(fechaInicial);
        params.fecha_final = dateToDayEnd(fechaFinal);

        return params;
    };

    const GetTrasladosReporte = async () => {
        if (!fechaInicial || !fechaFinal) {
            setTraslados([]);
            setCantidadResultados(0);
            setTotalesTraslados({});
            return;
        }

        try {
            const response = await getTrasladosReporte(
                construirParams(paginaSeleccionada),
            );
            setTraslados(response.results);
            setCantidadResultados(response.count);
            setTotalesTraslados(response.totales);
        } catch (error) {
            // Si el error es por una página inválida, volvemos a la página anterior
            if (
                error &&
                error.detail === "Invalid page." &&
                paginaSeleccionada > 1
            ) {
                setPaginaSeleccionada((prev) => prev - 1);
                return;
            }

            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener reporte de traslados",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            console.error("Error al obtener traslados:", error);
            setTraslados([]);
            setCantidadResultados(0);
            setTotalesTraslados({});
        }
    };

    const GetTrasladosGrafica = async () => {
        if (!fechaInicial || !fechaFinal) {
            setTrasladosGrafica([]);
            return;
        }

        try {
            const params = construirParams();
            params.modo = "grafica";

            const response = await getTrasladosReporte(params);
            setTrasladosGrafica(response.results);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener reporte de traslados",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            console.error("Error al obtener traslados:", error);
            setTrasladosGrafica([]);
        }
    };

    const FiltrarReporte = () => {
        if (!fechaInicial || !fechaFinal) {
            NotificationManager.warning(
                "Por favor, selecciona una fecha inicial y una fecha final para filtrar el reporte.",
                "Fechas incompletas",
                3000,
            );
            return;
        }

        if (paginaSeleccionada !== 1) {
            setPaginaSeleccionada(1);
        } else {
            GetTrasladosReporte();
        }

        GetTrasladosGrafica();
    };

    useEffect(() => {
        GetTrasladosReporte();
    }, [paginaSeleccionada]);

    // si se restauraron fechas guardadas en sessionStorage, cargar la gráfica también
    useEffect(() => {
        GetTrasladosGrafica();
    }, []);

    useEffect(() => {
        const stateToSave = {
            filtros: {
                fecha_inicial: fechaInicial,
                fecha_final: fechaFinal,
            },
            pagina: paginaSeleccionada,
        };

        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stateToSave));
    }, [fechaInicial, fechaFinal, paginaSeleccionada]);

    const ObtenerReporteExcel = async () => {
        if (!fechaInicial || !fechaFinal) {
            NotificationManager.warning(
                "Por favor, selecciona una fecha inicial y una fecha final para filtrar el reporte.",
                "Fechas incompletas",
                3000,
            );
            return;
        }

        try {
            await obtenerReporteExcel(construirParams());
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el reporte en Excel",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    return (
        <div className="listado-traslados__tab-wrapper">
            <LoadMask loading={cargando || cargandoDetalle} blur>
                <CardEmpty noShadow>
                    <div className="reporte-traslados__table-header">
                        <FiltrosReporte
                            fechaInicial={fechaInicial}
                            setFechaInicial={setFechaInicial}
                            fechaFinal={fechaFinal}
                            setFechaFinal={setFechaFinal}
                            onFiltrar={FiltrarReporte}
                        />
                        <div className="ml-auto formulario-fields-row flex-nowrap">
                            <div className="formulario-field">
                                <button
                                    className="btn btn-primary mt-auto text-nowrap"
                                    onClick={ObtenerReporteExcel}
                                    disabled={!traslados.length}
                                >
                                    Exportar Excel
                                </button>
                            </div>
                        </div>
                    </div>

                    {traslados.length > 0 && (
                        <GraficaTraslados traslados={trasladosGrafica} />
                    )}

                    <ListadoIndividualTable
                        traslados={traslados}
                        totalesTraslados={totalesTraslados}
                        verDetalleTraslado={VerDetalleTraslado}
                    />
                    <Paginacion
                        cantidadResultados={cantidadResultados}
                        paginaSeleccionada={paginaSeleccionada}
                        setPaginaSeleccionada={setPaginaSeleccionada}
                    />
                </CardEmpty>
            </LoadMask>
            {trasladoSeleccionado && (
                <ModalIngresos
                    opened={!!trasladoSeleccionado}
                    onClose={() => setTrasladoSeleccionado(null)}
                    trasladoSeleccionado={trasladoSeleccionado}
                />
            )}
        </div>
    );
};
